/**
 * CRO-WEB-173 Experiment Configuration
 *
 * Configuration for the onboarding welcome step design experiment.
 */

import type { ExperimentConfig } from "@/src/experiments/useExperimentTracking";
import { getCroWeb173Variant } from "./getCroWeb173Variant";

export const croWeb173Config: ExperimentConfig = {
  name: "cro-web-173",
  getVariant: getCroWeb173Variant,
  eventName: "cro_web_173_experiment_participation",
  featureFlagName: "cro-web-173",
  variants: [
    "control",
    "social-proof-no-features",
    "social-proof-no-features-no-hero",
    "social-proof-features-no-hero",
  ],
};
